
const loadAlgoliaSearch = () =>
  Promise.all([
    import('@/components/AlgoliaSearch.vue'),
    import('vue-instantsearch'),
    import('instantsearch.css/themes/algolia-min.css'),
  ])

export default {
  name: 'HeaderSearchAlgolia',
  data() {
    return {
      ready: false,
      searchReady: false,
      shouldFocus: false,
      pendingSearch: this.$route.query.q || '',
    }
  },
  watch: {
    '$route.query.q'(q) {
      this.pendingSearch = q || ''
    },
  },
  methods: {
    warm() {
      if (!this.loadAlgoliaSearchPromise) {
        this.loadAlgoliaSearchPromise = loadAlgoliaSearch().then(
          () => true,
          error => {
            this.loadAlgoliaSearchPromise = null
            if (
              error.name === 'ChunkLoadError' ||
              error.code === 'CSS_CHUNK_LOAD_FAILED'
            ) {
              return false
            }
            throw error
          }
        )
      }
      return this.loadAlgoliaSearchPromise
    },
    async activate() {
      if (await this.warm()) {
        this.ready = true
      }
    },
    onInputReady() {
      this.shouldFocus = this.$el.contains(document.activeElement)
      this.searchReady = true
    },
    submitPendingSearch() {
      this.activate()
      if (!this.pendingSearch) return
      this.$router.push(
        this.localePath({
          path: this.$route.path,
          query: { q: this.pendingSearch },
        })
      )
    },
  },
}
